import React from "react";
import { Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Header.css";

const Header = () => {
  return (
    <Navbar
      variant="dark"
      expand="lg"
      style={{ background: "rgba(16, 18, 24,.5)", color: "#45a29e" }}
    >
      <div className="container">
        <Link className="navbar-brand" style={{ color: "#45a29e" }} to="/">
          JUBAYER
        </Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Link className="nav-link" style={{ color: "#45a29e" }} to="/home">
              Home
            </Link>
            {/* <Link className="nav-link" style={{ color: "#45a29e" }} to="/about">
              About
            </Link> */}
            <Link
              className="nav-link"
              style={{ color: "#45a29e" }}
              to="/projects"
            >
              Projects
            </Link>
            <Link className="nav-link" style={{ color: "#45a29e" }} to="/blog">
              Blog
            </Link>
            <Link
              className="nav-link"
              style={{ color: "#45a29e" }}
              to="/contact"
            >
              Contact
            </Link>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};

export default Header;

// bg="dark" variant="dark"
